import { LanguageEnum } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import TimestampPayload from '@/store/actions/TimestampPayload';

export interface LanguageLocaleChangedPayload {
  languageEnum: LanguageEnum;
}
export type LanguageLocaleChangedActionType = Action<LanguageLocaleChangedPayload>;
export const languageLocaleChanged = createAction<LanguageLocaleChangedPayload>('LANGUAGE_LOCALE_CHANGED');

export type SelectedLanguageUpdatedPayload = TimestampPayload;

export const selectedLanguageUpdated = createAction<SelectedLanguageUpdatedPayload>('SELECTED_LANGUAGE_UPDATED');
